import { STORE_MUTATION } from "../enums";
import { MessageContent } from "../types";
import { store } from "../store/store";
import { IPageConfig } from '../interfaces/page_config';

/**
 * Assign a value to a variable if it exists, otherwise assign a default value.
 */
function assignValueIfExists<T>(value: T | undefined, defaultValue: T): T {
  return value !== undefined ? value : defaultValue;
}

/**
 * SD-6443: Update the store with the config message settings.
 * @param message The config message to process.
 */
export const onConfigMessageFromServer = async function (message: MessageContent) {
  try {
    // If the message is not a config message, ignore it.
    if (!message.settings) {
      return;
    }

    // Get the settings from the message
    let settings: IPageConfig = {
      inputContainerPlaceholderText: assignValueIfExists(message.settings.inputContainerPlaceholderText, ""),
      messageTimeFormat: assignValueIfExists(message.settings.messageTimeFormat, ""),
      sendingIndicatorText: assignValueIfExists(message.settings.sendingIndicatorText, ""),
      taglineText: assignValueIfExists(message.settings.taglineText, ""),
      languageCode: assignValueIfExists(message.settings.languageCode, ""),
      formLabels: assignValueIfExists(message.settings.formLabels, {}),
    };

    // Update the store with the config message settings
    store.commit(STORE_MUTATION.SetUpdatePageConfig, { payload: settings });

  } catch (ex) {
    //onExceptionOccured("onConfigMessageFromServer", ex);
  }
};
